<div class="ui container" *ngIf="data">
    <div class="ui grid">
        <div class=" sixteen  wide column ">
            <h2 class='title-style '>ADMINISTRACIÓN DE PUNTAJES</h2>
            <div style='margin-top: 30px;'>
                <div class="ui grid" *ngFor="let activity of data">
                    <div class=" height  wide column ">
                        <p class='font-gray label-puntaje '> {{activity.description}}</p>
                    </div>
                    <div class=" three  wide column center">
                        <div class="ui input ">
                            <input type="number" step=".01" min='0' [(ngModel)]="activity.valorization">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="ui grid mt">
        <div class="sixteen wide column ">
            <h2 class='title-style '>PREGUNTAS </h2>
            <div style='margin-top: 15px;' *ngIf="data.length>0">
                <div class="title-activity">
                    {{data.description}}
                </div>
                <div>
                    <div *ngFor="let actividad of data">
                        <div style="height: 5em;">

                            <div class="ui grid">
                                <div class=" height  wide column ">
                                </div>

                                <div class=" three  wide column center" style="margin-bottom: 1em;">


                                </div>
                                <div class=" three  wide column center">
                                </div>
                            </div>
                            <div class="ui grid">
                                <div class=" height  wide column ">
                                    <h2 class='title-actividad subtitle'>{{actividad.description}}</h2>
                                </div>
                                <div class=" three  wide column center">

                                    <span class='font-gray label-puntaje-2 ui input '> Puntos</span>
                                </div>
                                <div class=" three  wide column center">
                                    <span class='font-gray label-puntaje-2  '> Respuesta esperada</span>
                                </div>
                            </div>
                        </div>

                        <div class="ui grid">
                            <div class=" fourteen  wide column ">
                                <div class="ui divider "></div>
                            </div>
                        </div>
                        <app-preguntas (changeEmitter)='onChangeEvent($event)' *ngFor="let p of actividad.instructions"
                            [activityId]="actividad.id" 
                            [data]="p">
                        </app-preguntas>
                    </div>



                </div>
            </div>



        </div>
    </div>
    <div class="ui grid">
        <div class=" fourteen  wide column " style="padding: 0px!important;">
            <div class="ui divider "></div>
        </div>
    </div>
    <div class="ui grid">
        <div class="extra content">
            <button (click)="guardar()" class="ui right labeled icon button button-filter primary">
                <i class="edit
                          icon"></i>
                Guardar
            </button>

            <button class="ui right labeled icon button button-filter primary" (click)="goHome()">
                <i class="home
                          icon"></i>
                Volver
            </button>
        </div>
    </div>
</div>